import { forwardRef } from 'react';
import { BaseScrollable } from './__internal__/BaseScrollable';
import { jsx as _jsx } from "react/jsx-runtime";
export const Scrollable = /*#__PURE__*/forwardRef(function Scrollable(props, ref) {
  return /*#__PURE__*/_jsx(BaseScrollable, {
    ...props,
    ref: ref
  });
});
//# sourceMappingURL=Scrollable.js.map